import UserService from "rc-app/services/UserService";
import axios from "axios";

export const getCustomerList = async (
  page = 0,
  limit = 20,
  agencyId = "",
  agentId = "",
  mobile = "",
  email = "",
) => {
  try {
    let API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_customer?sort_by=created_at&sort_order=-1&page=${page}&limit=${limit}`;

    if (agencyId) API_URL += `&agency_id=${agencyId}`;
    if (agentId) API_URL += `&agent_id=${agentId}`;
    if (mobile) API_URL += `&mobile_number=${mobile}`;
    if (email) API_URL += `&email_id=${email}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching customer list:", error);
    throw error;
  }
};

export const getCustomerById = async (customerId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_customer/${customerId}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getCustomerProfile = async (email_id) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_customer/profile/${email_id}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const createReCustomer = async (jsonData) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_customer`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const updateCustomer = async (customerId, jsonData) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_customer/${customerId}`;

    const response = await axios.put(API_URL, jsonData, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};


export const deleteCustomer = async (clientId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_customer/${clientId}`;

    const response = await axios.delete(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const assignAgentToCustomer = async (customerId, agentId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_customer/${customerId}`;
    const PAYLOAD = {
      agent_id: [agentId],
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error assigning agent to customer:", error);
    throw error;
  }
};

export const unassignAgentFromCustomer = async (customerId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_customer/${customerId}`;
    const PAYLOAD = {
      agent_id: [],
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error unassigning agent from customer:", error);
    throw error;
  }
};

/* Shortlist properties of a cutomer by email ID */

export const shortlistPropertiesOfCustomerByEmailId = async (
  emailId,
  setIsDataLoaded,
) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_customer/profile/${emailId}/property_shortlist?sort_by=created_at&sort_order=-1&page=1&limit=1000 `;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};

/* Add Property inti shortlist for a selected customer */

/**
 * Filter out shortlisted properties from the main list
 * @param {string} customerId - CustomerId
 * @param {Array} properties - Array of properties to be added imn shortlist
 * @returns {Object} - object of Customer with array shortlist properties
 */
export const addPropertyToShortlist = async (
  customerId,
  selectedProperties,
) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/agent/add_property_to_client_property_shortlist/${customerId}`;
    const PAYLOAD = [...selectedProperties];
    console.log("jsonpayload", PAYLOAD);

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    console.log("addPropertyToShortlist", response);

    return response;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

export const addShortlist = async (customerId, properties) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/agent/add_property_to_client_property_shortlist/${customerId}`;

    const response = await axios.put(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error("Error fetching properties:", error);
  }
};
